var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDevices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0.75H5C2.54 0.75 0.5 2.76 0.5 5.25V41.25C0.5 43.74 2.54 45.75 5 45.75H23V54.75H14V59.25H50V54.75H41V45.75H59C61.49 45.75 63.5 43.74 63.5 41.25V5.25C63.5 2.76 61.49 0.75 59 0.75ZM36.5 54.75H27.5V45.75H36.5V54.75ZM59 41.25H5V5.25H59V41.25Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevices);
export default __webpack_public_path__ + "static/media/ic-devices.4af352c7022e496dac5425c726867ef1.svg";
export { ForwardRef as ReactComponent };